import DynamicObject from "../../models/dynamic-object";
import { AxiosResponse} from "axios";
import Api from "../api";

export default (config?: DynamicObject): Promise<AxiosResponse> => {
    const path = 'sites/shorten'
    return Api.getInstance().request.post(`${path}`, config, path)
}